import Service from '../Service'
import {http} from '../config'

export default class BeneficiarioService extends Service{

    constructor(){
        super('beneficiario');
    }

    GetFiltro(parametros, filter){
        
        if (filter) {
            let paramTemp = '';
            
            if(filter.beneficiario){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `Contains(nome,'${filter.beneficiario}')`;
            }

            // if(filter.idadeInicial >= 0){
            //     if (paramTemp) { paramTemp += ' and '; }
            //     paramTemp += `idade ge ${filter.idadeInicial}`;
            // }

            // if(filter.idadeFinal >= 0){
            //     if (paramTemp) { paramTemp += ' and '; }
            //     paramTemp += `idade le ${filter.idadeFinal}`;
            // }
    
            if (paramTemp) {
    
                if(parametros){
                    parametros += '&';
                }
                else {
                    parametros += '?';
                }

                parametros += `$filter=${paramTemp}`;
            }
    
        }
    
        return parametros;
    }

    AutoComplete(q){
        return http.get(this.getNomeControle() + "/AutoComplete?q=" + q);
    }

    VerificarExistente(cpfCnpj) {
        return http.get(this._nomeControle + "/VerificarExistente", {
            params: {
                cpfCnpj
            }
        });
    }

    FiltroComplementar(page, pageSize, sortby, desc, search, columns, filter, mesInicial, mesFinal, anoInicial, anoFinal, idadeInicial, idadeFinal){
        
        let parametros = this.GetParamentroPaginacaoOrdenacao(page, pageSize, sortby, desc, search, columns);
        
        parametros = this.GetFiltro(parametros, filter);

        return http.get(`${this._nomeControle}/FiltroComplementar/${parametros}`, {
            params:{
                mesInicial,
                mesFinal,
                anoInicial,
                anoFinal,
                idadeInicial,
                idadeFinal
            }
        });
    }

    Totalizadores(search, columns, filter, mesInicial, mesFinal, anoInicial, anoFinal, idadeInicial, idadeFinal){
        let parametros = this.GetParamentroPaginacaoOrdenacao(null, null, null, [], search, columns);
        parametros = this.GetFiltro(parametros, filter);

        if(parametros === '?'){
            parametros = '';
        }

        return http.get(`${this._nomeControle}/Totalizadores${parametros}`, {
            params:{
                mesInicial,
                mesFinal,
                anoInicial,
                anoFinal,
                idadeInicial,
                idadeFinal
            }
        });
    }

    PorProjeto(projetoId, somenteProjetoAberto, mesNascimentoInicial, mesNascimentoFinal, anoNascimentoInicial, anoNascimentoFinal, nome, idadeInicial, idadeFinal){
        return http.get(`${this._nomeControle}/PorProjeto`, {
            params:{
                projetoId: projetoId,
                somenteProjetoAberto: somenteProjetoAberto,
                mesNascimentoInicial: mesNascimentoInicial,
                mesNascimentoFinal: mesNascimentoFinal,
                anoNascimentoInicial: anoNascimentoInicial,
                anoNascimentoFinal: anoNascimentoFinal,
                nome: nome,
                idadeInicial: idadeInicial,
                idadeFinal: idadeFinal
            }
        });
    }

    Foto(id){
        return http.get(`${this._nomeControle}/${id}/foto`);
    }

    EnviarDocumento(id, arquivo){
        let bodyFormData = new FormData();

        var blob = new Blob([arquivo], { type: 'image/jpg' });

        bodyFormData.append('arquivo', blob);

        return http.post(`${this.getNomeControle()}/${id}/foto`, bodyFormData, {
            headers: {'Content-Type': 'multipart/form-data' }
        });
    }

    ExcluirFoto(id){
        return http.delete(`${this._nomeControle}/${id}/foto`);
    }
    
    Aniversariantes(){
        return http.get(`${this._nomeControle}/Aniversariantes`);
    }

    CarregarCoordenadasMapa(){
        return http.get(`${this._nomeControle}/CarregarCoordenadasMapa`);
    }
}
